import {
	LearningPhaseCard,
	type LearningPhaseCardProps,
} from '#app/components/landings/blocks/LearningPhaseCard.tsx'
import { cn } from '#app/utils/misc.tsx'

export interface LearningPhaseShowcaseProps {
	eyebrow?: string
	title?: string
	subtitle?: string
	background?: 'default' | 'muted' | 'primary-light'
	phases?: LearningPhaseCardProps[]
}

const backgroundStyles = {
	default: 'bg-background',
	muted: 'bg-muted/30',
	'primary-light': 'bg-primary/5',
}

export function LearningPhaseShowcase({
	eyebrow,
	title,
	subtitle,
	background = 'default',
	phases = [],
}: LearningPhaseShowcaseProps) {
	if (!eyebrow && !title && !subtitle && phases.length === 0) {
		return null
	}

	return (
		<section className={cn('py-16 md:py-24', backgroundStyles[background])}>
			<div className="container mx-auto flex max-w-6xl flex-col gap-8 px-4 md:px-6">
				{(eyebrow || title || subtitle) && (
					<header className="mx-auto flex max-w-4xl flex-col gap-4 text-center">
						{eyebrow && (
							<span className="text-label text-muted-foreground">
								{eyebrow}
							</span>
						)}
						{title && <h2 className="text-title-2 text-foreground">{title}</h2>}
						{subtitle && (
							<p className="text-muted-foreground text-base leading-relaxed md:text-lg">
								{subtitle}
							</p>
						)}
					</header>
				)}

				<div className="space-y-5 md:space-y-6">
					{phases.map((phase, index) => (
						<LearningPhaseCard
							key={`${phase.title || 'phase'}-${index}`}
							{...phase}
							embedded
						/>
					))}
				</div>
			</div>
		</section>
	)
}
